<style lang="less" scoped>
.Message {position: relative;width: 600px;height: 200px;text-align: left;margin-top:-20px;margin-left:-40px;margin-right:40px;font-family: AlibabaPuHuiTi-Regular;font-size: 14px;}
ul {list-style: none;height: 300px;overflow: hidden;}
li {display:flex;margin-top:5px;margin-bottom:5px;width: 600px;border-bottom: 1px solid #f6f6f6;line-height: 33px;}
.title{float:left;width:350px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
.type{position:absolute;right: 5px;}
</style>

<!--李旭 2021.6.29-->
<template>
  <div class="Message">
    <ul class="list">
    <li v-for="(item, index) in messageLists" :key="index" @click="clickNewsMessages(item)">
      <span class="title"> {{ item.title }} </span>
      <span class="title"> {{ item.time *1000 | formatDate()}} </span>
      <span class="type">{{item.type}}</span>
    </li>
  </ul>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  props: ['messageLists'],
  mixins: [filters],
  data()
  {
    return {
    }
  },
  methods: {
    // 点击公司名称，将 整个公司对象 传递给父组件
    clickNewsMessages(item)
    {
      this.$emit('clickNews', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/Messages.vue